/*
login-footer.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('login/modules/login-footer/login-footer',['angular', './controllers/login-footer-ctrl'], function () {

    // Module Dependencies
    var dependencies = [
        'LoginFooter.Controllers.LoginFooterCtrl'
    ];

// Module Creation
    angular.module('Login.Modules.LoginFooter', dependencies);

});

